import React from 'react';
import classnames from 'classnames';

import Is, { Props as IsProps, IsComponent } from '@/components/Is';

import style from './AspectRatio.sass';

export type Props<P extends IsComponent> = IsProps<P> & {
  ratio: number;
  className?: string;
  contentClassName?: string;
};

export default class AspectRatio<P extends IsComponent> extends React.PureComponent<Props<P>> {
  static defaultProps: Pick<Props<any>, 'is'> = {
    is: 'div'
  };

  render() {
    const { ratio, className, contentClassName, children, ...rest } = this.props;

    return (
      // @ts-ignore
      <Is {...rest} className={classnames(style.root, className)} style={{ paddingBottom: `${100 / ratio}%` }}>
        <div className={classnames(style.content, contentClassName)}>{children}</div>
      </Is>
    );
  }
}
